import { DotLottie } from '@lottiefiles/dotlottie-web';
import { CommonApiService } from '@services/common-api-service';
import { Component, Element, Event, EventEmitter, Host, Prop, State, h } from '@stencil/core';
import { pathStore } from '@store/path-store';
import { ConfigService } from '../../../../services/config-service';

@Component({
  tag: 'general-consent',
  styleUrl: 'general-consent.scss',
  shadow: true
})
export class GeneralConsent {
  @Prop() activeProgram: string;
  @Prop() redirectDomainUrl: string = '';
  @Prop() allowedCardTypes: string[] = ['infinia', 'regalia', 'regaliagold', 'corporate', 'business', 'diners', 'irctc-co-brand'];
  @Prop() selectedCard: any = {};
  @Element() el!: HTMLElement;

  @State() isVisible: boolean = false;
  @State() isLeaving: boolean = false;
  @State() Cookies = {
    GA: false,
    AL: false,
    GTM: false
  };
  @State() cookieConsent = true;
  @State() ShowCookiePopup = true;

  @Event() cookieConsentChange!: EventEmitter<number>;
  private apiService = new CommonApiService();

  // componentDidLoad() {
  //   const container = this.el.shadowRoot?.querySelector('#lottie-cookie') as HTMLCanvasElement;
  //   if (container) {
  //     this.loadLottie(container);
  //   }
  // }

  componentDidUpdate() {
    const container = this.el.shadowRoot?.querySelector('#lottie-cookie') as HTMLCanvasElement;
    if (!container) {
      console.warn('Canvas element not found');
      return;
    }
    this.loadLottie(container);
  }

  componentWillLoad() {
    if (ConfigService.cookieConsentName) {
      const consentCookie = this.getCookie(ConfigService.cookieConsentName);
      if (Number(consentCookie)) {
        this.isVisible = false;
      } else {
        this.isLeaving = false;
        setTimeout(() => {
          this.isVisible = true;
        }, 300);
      }
    } else {
      console.log("Cookie consent name not found");
    }
  }

  // private getCookiePolicyUrl(): string {
  //   const { protocol, hostname } = window.location;
  //   const baseUrl = `${protocol}//${hostname}`;
  //   const programPath = (this.activeProgram === 'default' || this.activeProgram === 'base') ? '' : `${this.activeProgram}/`;
  //   return `${baseUrl}/${programPath}cookie_policy`;
  // }

  private getCookiePolicyUrl(): string {
    return new URL(`/cookie_policy`, this.redirectDomainUrl).toString();
  }

  private loadLottie(container: HTMLCanvasElement) {
    const assetPath = pathStore.assetPath;
    const src = `${assetPath}images/lottie/cookie.lottie`;
    new DotLottie({
      canvas: container,
      autoplay: true,
      loop: true,
      src
    });
  }

  private handleConsent = (value: number) => {
    this.cookieConsentChange.emit(value);
    this.dismissConsent();
    this.applyCookieConsent(value);
  };

  private dismissConsent = () => {
    this.isLeaving = true;
    setTimeout(() => {
      this.isVisible = false;
    }, 300);
  };

  private applyCookieConsent = async (value: number) => {
    try {
      let finalValue: string | number = value;

      if (value === 1) {
        this.Cookies = { GA: true, AL: true, GTM: true };
      } else if (value === 2) {
        this.Cookies = { GA: false, AL: false, GTM: false };
      } else if (value === 3) {
        const cookie_value = ['SN'];
        if (this.Cookies.GA) cookie_value.push('GA');
        if (this.Cookies.AL) cookie_value.push('AL');
        if (this.Cookies.GTM) cookie_value.push('GTM');
        finalValue = cookie_value.join(',');
      }

      const formData = new FormData();
      formData.append('name', 'accept-cookie');
      formData.append('value', String(finalValue));
      await this.apiService.setCookie('/api/setCookieConsent', formData);
    } catch (error) {
      console.log(error);
    }
  };

  private getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  render() {
    if (!this.isVisible) return null;

    const className = `consent-bar ${this.isLeaving ? 'leave' : 'enter'} py-6 md:py-3 px-6 `;

    return (
      <Host>
        <div class={className}>
          <div class="flex justify-between flex-col sm:flex-row gap-6 sm:gap-3">
            <div class="flex gap-3 items-center flex-col sm:flex-row">
              <canvas id="lottie-cookie" class="size-24 scale-[2] md:scale-100" />
              <div>
                <p class="font-bold text-white">We Use Cookies</p>
                <p>
                  By using this site you agree to SmartBuy’s use of cookies to give you a personalised experience. For more, please read the{' '}
                  <a class="underline cursor-pointer text-sb-primary" href={this.getCookiePolicyUrl()} target="_blank">
                    cookie policy.
                  </a>
                </p>
              </div>
            </div>
            <div class="flex gap-2 items-center justify-center">
              <custom-button class="flex-1 w-full sm:w-auto" onButtonClick={() => this.handleConsent(1)}>
                Accept
              </custom-button>
              <custom-button class="flex-1 w-full sm:w-auto" variant="outlined" onButtonClick={() => this.handleConsent(2)}>
                Deny
              </custom-button>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
